// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".application-tab[data-v-28770efc]{position:relative;padding-left:15px}.application-tab[data-v-28770efc] >div{position:absolute;top:115px}", ""]);
// Exports
module.exports = exports;
